import { useNavigate } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useAuth } from './AuthContext';

interface PublicTenant { id: number; name: string }

interface Props {
  title: string;
  /** Se omesso, mostra il nome del distaccamento dell'utente loggato. Passa "" per nascondere. */
  subtitle?: string;
  actions?: React.ReactNode;
  /** URL di destinazione del bottone "← Indietro". Default: /dashboard. Passa null per nascondere. */
  backTo?: string | null;
  backLabel?: string;
}

/**
 * Header pagina in stile legacy:
 *   [titolo grande emoji + sottotitolo distaccamento]   [azioni + ← Indietro]
 *   ────────────────────────────────────────────────────────────────
 */
export function PageHeader({ title, subtitle, actions, backTo = '/dashboard', backLabel = '← Torna Indietro' }: Props): React.JSX.Element {
  const navigate = useNavigate();
  const { user } = useAuth();

  const { data: tenants } = useQuery<PublicTenant[]>({
    queryKey: ['tenants.public'],
    queryFn: async () => (await api.get('/tenants/public')).data,
    enabled: subtitle === undefined,
  });

  const stationName = subtitle ?? (user ? tenants?.find(t => t.id === user.homeTenantId)?.name ?? '' : '');

  return (
    <header className="app-page-header">
      <div>
        <h1 className="app-page-title">{title}</h1>
        {stationName && <p className="app-page-subtitle">{stationName}</p>}
      </div>
      <div className="app-page-actions">
        {actions}
        {backTo !== null && (
          <button className="btn-back" onClick={() => navigate(backTo)}>{backLabel}</button>
        )}
      </div>
    </header>
  );
}
